import { types } from 'mobx-state-tree'
import { VirtualCardStatus } from '../dictionaries'

export const VirtualCardLimit = types.model('VirtualCardLimit', {
  cycleType: types.enumeration([
    'PER_TRANSACTION',
    'DAY',
    'MONTH',
    'YEAR',
    'LIFE_TIME',
  ]),
  remaining: types.string,
  type: types.enumeration(['VOLUME', 'COUNT']),
  value: types.string,
})

export const VirtualCard = types
  .model('VirtualCard', {
    cardExpiryDate: types.string,
    cardId: '',
    cardLimit: '',
    cardMaskNumber: '',
    cardName: '',
    cardNumber: types.string,
    cardStatus: types.enumeration([
      'ACTIVATED',
      'EXPIRED_CARD',
      'TEMPORARY_BLOCKED_BY_CLIENT',
    ]),
    cardType: '',
    mccGroupId: '',
    countryGroupId: '',
    createdDate: '',
    limits: types.array(VirtualCardLimit),
    singleUseCard: '',
    cvv: types.string,
  })
  .views((self) => {
    return {
      get expiry() {
        const e = self.cardExpiryDate
        return `${e.slice(4)}/${e.slice(0, 4)}`
      },
      get expiryByTwoLetters() {
        const e = self.cardExpiryDate
        return `${e.slice(4)}/${e.slice(2, 4)}`
      },
      get ccNumber() {
        const cardNum = self.cardNumber
        const formatedCard = cardNum.match(/.{1,4}/g)?.join(' ')
        return formatedCard
      },
      get status() {
        const status = self.cardStatus
        switch (status) {
          case VirtualCardStatus.ACTIVE:
            return 'Active'
          case VirtualCardStatus.EXPIRED:
            return 'Expired'
          case VirtualCardStatus.TEMPORARY_BLOCKED_BY_CLIENT:
            return 'Temporary Blocked'
          default:
            return status
        }
      },
      get approvedAmount() {
        return +self.limits[0].value
      },
    }
  })

export const CardHolder = types
  .model('CardHolder', {
    addressLine1: '',
    addressLine2: '',
    cardHolderId: '',
    city: '',
    country: '',
    emailId: '',
    firstName: '',
    phoneNumber: '',
    state: '',
    zipCode: '',
  })
  .views((self) => {
    return {
      get businessAddress() {
        return `${self.addressLine1}\n${self.city}, ${self.state} ${self.zipCode}`
      },
    }
  })
